module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('em', [_vm._v("Christmas is coming, the goose is getting fat,"), _c('br'), _vm._v("Please put a penny in the old man’s hat.")]), _c('br'), _c('em', [_vm._v("If you haven’t got a penny, a ha’penny will do,"), _c('br'), _vm._v("If you haven’t got a ha’penny, then God bless you!")])]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Traditional British children’s rhyme")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“When I was a lad,” replied the foreman, “young ladies was young ladies. And young gentlemen was young gentlemen. If you get my meaning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What this country wants,” said Padgett, “is a ’Itler.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Dorothy L. Sayers, "), _c('em', [_vm._v("Gaudy Night")]), _vm._v(" (1935)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a23a39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 72
// module chunks = 0